import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "./RadarPage.css";
import dbzsAudio from "../assets/dbzs.mp3";

function RadarPage() {
    const navigate = useNavigate();
    const [clickedSteps, setClickedSteps] = useState([]);
    const [unlockedSteps, setUnlockedSteps] = useState([1]);
    const [answers, setAnswers] = useState({});
    const [showCompletionMessage, setShowCompletionMessage] = useState(false);
    const [successAnimatingStep, setSuccessAnimatingStep] = useState(null);
    const inputRefs = useRef({});
    const checkpointRefs = useRef({});

    const dragonBalls = [
        {
            id: 1,
            title: "Dragon Ball 1★",
            question: "You have to begin right!! Find gloves to fight!!",
            correctAnswer: "goku"
        },
        {
            id: 2,
            title: "Dragon Ball 2★",
            question: "Second ball's stuck in a pocket!! find the tm Jacket!!",
            correctAnswer: "saitama#"
        },
        {
            id: 3,
            title: "Dragon Ball 3★",
            question: "Window AC, look up up up!!!!!!",
            correctAnswer: "gojobhai"
        },
        {
            id: 4,
            title: "Dragon Ball 4★",
            question: "say 'SpyxFamily' to jinka favorite anime hai ye",
            correctAnswer: "mummy"
        },
        {
            id: 5,
            title: "Dragon Ball 5★",
            question: "its the 5th, don't be loose!! quick!! find the Kryptonian shoes!!",
            correctAnswer: "batman"
        },
        {
            id: 6,
            title: "Dragon Ball 6★",
            question: "inside reflection near shower!! there's the sixth ball to power!!",
            correctAnswer: "laalo"
        },
        {
            id: 7,
            title: "Dragon Ball 7★",
            question:
                "To come till here!! The GREAT SAIYAN DEVESH!! You've gone to waterfalls, volcanos and 0-oxygen caves!! It's the ultimate ball, check out the tunnel below the heating waves!!",
            correctAnswer: "kazama"
        }
    ];

    const handleStepClick = id => {
        if (unlockedSteps.includes(id)) {
            if (clickedSteps.includes(id)) {
                // Hide question/input
                setClickedSteps(clickedSteps.filter(step => step !== id));
            } else {
                // Show question/input and focus
                setClickedSteps([...clickedSteps, id]);
                setTimeout(() => {
                    if (inputRefs.current[id]) {
                        inputRefs.current[id].focus();
                    }
                }, 100);
            }
        }
    };

    const slowScrollTo = (element, duration = 2000) => {
        const targetPosition =
            element.getBoundingClientRect().top +
            window.pageYOffset -
            window.innerHeight / 2 +
            element.offsetHeight / 2;
        const startPosition = window.pageYOffset;
        const distance = targetPosition - startPosition;
        let startTime = null;

        function animation(currentTime) {
            if (startTime === null) startTime = currentTime;
            const timeElapsed = currentTime - startTime;
            const progress = Math.min(timeElapsed / duration, 1);

            // Ease in-out function
            const ease = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;

            window.scrollTo(0, startPosition + distance * ease);

            if (timeElapsed < duration) {
                requestAnimationFrame(animation);
            }
        }

        requestAnimationFrame(animation);
    };

    const handleAnswerChange = (id, value) => {
        setAnswers({ ...answers, [id]: value });

        const ball = dragonBalls.find(b => b.id === id);
        if (ball && value.toLowerCase().trim() === ball.correctAnswer.toLowerCase()) {
            // Hide the question for this ball
            setClickedSteps(prev => prev.filter(step => step !== id));

            if (id === 7) {
                setShowCompletionMessage(true);

                if (window.currentAudio) {
                    window.currentAudio.pause();
                    window.currentAudio.currentTime = 0;
                }
                const audio = new Audio(dbzsAudio);
                audio.volume = 1.0;
                audio.loop = true;
                audio.play().catch(error => console.log("Audio play failed:", error));
                window.currentAudio = audio;

                setTimeout(() => {
                    navigate("/gift");
                }, 6000);
            } else {
                const nextId = id + 1;

                setUnlockedSteps(prev => [...prev, nextId]);
                setSuccessAnimatingStep(id);

                setTimeout(() => {
                    const nextCheckpoint = checkpointRefs.current[nextId];
                    const nextInput = inputRefs.current[nextId];

                    if (nextCheckpoint) {
                        slowScrollTo(nextCheckpoint, 2000);
                    }

                    setTimeout(() => {
                        setSuccessAnimatingStep(null);
                    }, 2100);
                }, 2000);
            }
        }
    };

    return (
        <div className="radar-page">
            {showCompletionMessage && (
                <div className="completion-overlay">
                    <div className="completion-message">
                        <h1 className="completion-title">🐉</h1>
                        <h1 className="completion-title">ALL 7 DRAGON BALLS COLLECTED!</h1>
                        <h1 className="completion-title">🐉</h1>
                        <p className="completion-subtitle">Summoning Shenron...</p>
                    </div>
                </div>
            )}
            <div className="radar-header">
                <h1 className="main-title">Collect all 7 Dragon Balls!!</h1>
                <h2 className="radar-title">Dragon Radar</h2>
            </div>

            <VerticalTimeline lineColor="#ff6b35">
                {dragonBalls.map(ball => {
                    const isUnlocked = unlockedSteps.includes(ball.id);
                    const isClicked = clickedSteps.includes(ball.id);
                    const isCurrentActive = isUnlocked && !answers[ball.id];
                    const isCompleted =
                        answers[ball.id] && answers[ball.id].toLowerCase().trim() === ball.correctAnswer.toLowerCase();

                    return (
                        <div
                            key={ball.id}
                            ref={el => (checkpointRefs.current[ball.id] = el)}
                            data-completed={isCompleted}
                            data-current={isCurrentActive}
                            data-success={successAnimatingStep === ball.id ? "true" : "false"}
                        >
                            <VerticalTimelineElement
                                key={ball.id}
                                className="vertical-timeline-element--work"
                                data-completed={isCompleted}
                                data-current={isCurrentActive}
                                contentStyle={{
                                    background: !isUnlocked ? "#888" : isClicked ? "#ffa500" : "#ff6b35",
                                    color: isCompleted ? "#00ff00" : "#fff",
                                    boxShadow: "0 3px 10px rgba(0,0,0,0.2)",
                                    opacity: !isUnlocked ? 0.5 : 1
                                }}
                                contentArrowStyle={{
                                    borderRight: !isUnlocked ? "7px solid #888" : "7px solid #ff6b35"
                                }}
                                iconStyle={{
                                    background: !isUnlocked ? "#888" : isClicked ? "#ffa500" : "#ff6b35",
                                    color: isCompleted ? "#00ff00" : "#fff",
                                    cursor: isUnlocked ? "pointer" : "not-allowed",
                                    opacity: !isUnlocked ? 0.5 : 1
                                }}
                                iconClassName={
                                    isUnlocked ? (isCurrentActive ? "data-current-true" : "data-unlocked-true") : ""
                                }
                                icon={
                                    <span className="star-icon" onClick={() => handleStepClick(ball.id)}>
                                        {isUnlocked ? `${ball.id}★` : "🔒"}
                                    </span>
                                }
                            >
                                <h3 className="vertical-timeline-element-title">
                                    {ball.title}
                                    {isCompleted ? " Collected" : ""}
                                </h3>
                                {isUnlocked && isClicked && (
                                    <div className="question-container">
                                        <p className="checkpoint-question">{ball.question}</p>
                                        <input
                                            ref={el => (inputRefs.current[ball.id] = el)}
                                            type="text"
                                            className="checkpoint-answer"
                                            placeholder="Type your answer..."
                                            value={answers[ball.id] || ""}
                                            onChange={e => handleAnswerChange(ball.id, e.target.value)}
                                        />
                                    </div>
                                )}
                                {!isUnlocked && (
                                    <p className="locked-message">Complete previous checkpoint to unlock</p>
                                )}
                            </VerticalTimelineElement>
                        </div>
                    );
                })}
            </VerticalTimeline>
        </div>
    );
}

export default RadarPage;
